var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "dsf-control ds-schedule",
    },
    [
      _vm.classInfo
        ? _c("div", { staticClass: "className" }, [
            _vm._v(_vm._s(_vm.classInfo.name || "")),
          ])
        : _vm._e(),
      _c("dsf-calendar-nav", {
        ref: "schedule",
        attrs: {
          "is-design": _vm.isDesign,
          url: _vm.url1,
          "to-day": _vm.toDay,
          "is-switch": _vm.isSwitch,
          "data-loaded-fun": _vm.dataLoadedFun,
          "is-parameter": _vm.isParameter,
          type: _vm.settingConfig.type,
        },
        on: { change: _vm.scheduleChange },
      }),
      _c(
        "div",
        { staticClass: "ds-schedule-content" },
        [
          !_vm.loading && !_vm.list.length ? _c("dsf-empty-data") : _vm._e(),
          _c(
            "div",
            { staticClass: "add" },
            [
              !_vm.loading && !_vm.list.length && _vm.showAdd
                ? _c(
                    "dsf-button",
                    {
                      attrs: { title: "添加日程", size: "small", icon: "add" },
                      on: { click: _vm.addSchedule },
                    },
                    [_vm._v("添加日程")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._t(
            "list",
            function () {
              return [
                _vm._l(_vm.list, function (item, index) {
                  return [
                    _c(
                      "div",
                      { key: index, staticClass: "ds-schedule-item-slot" },
                      [
                        _vm._t(
                          "default",
                          function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "ds-schedule-item" },
                                [
                                  _vm._t("default", function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ds-schedule-item-title",
                                          class: {
                                            ellipsis:
                                              _vm.settingConfig.ellipsis,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.theme || "") + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ds-schedule-item-info",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ds-schedule-item-time",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.startTime || "") +
                                                  " - " +
                                                  _vm._s(item.endTime || "") +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          !_vm.classInfo
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "ds-schedule-item-className",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.addressText || ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          },
                          { item: item, index: index }
                        ),
                      ],
                      2
                    ),
                  ]
                }),
              ]
            },
            { list: _vm.list }
          ),
          _vm._t("list-bottom"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }